var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
export class ChoiceEval {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    get isComplete() {
        if (this.question.isCompletedPrematurely)
            return true;
        if (this.completeMode === 'allCorrectSelected') {
            return !this.question.options.find(option => option.isOpenToBeSelected);
        }
        return this.selectedOptions.length >= this.question.choiceInfo.optionsToBeSelected.length;
    }
    get selectedOptions() {
        return this.question.options.filter(o => o.isSelected);
    }
    get optionsOpenToBeSelected() {
        return this.question.options.filter(option => option.isOpenToBeSelected);
    }
    get correctlySelectedOptions() {
        return this.question.options.filter(option => option.isCorrectlySelected);
    }
    get completeMode() {
        if (this.question.questionLayout.layoutBundle && this.question.questionLayout.layoutBundle) {
            return (this.question.questionLayout.layoutBundle.context.contextSignals.signalValueOf('completeWhen') || 'nSelected');
        }
        return 'nSelected';
    }
}
__decorate([
    computed
], ChoiceEval.prototype, "optionsOpenToBeSelected", null);
__decorate([
    computed
], ChoiceEval.prototype, "correctlySelectedOptions", null);
